import {Chip, Chips} from '@mantine/core';
import React, {useEffect, useState} from 'react';
import {getDivisions} from "../../../../../services/divisionService";
import {Division, KpiFilterState, KpiProps, SelectableItem} from "../../../../../types/types";

import "./KpiTargetFilterConfigurationStepper.css"
import {useAuth} from "../../../../../providers/AuthProvider";
import {Loader} from "../../../../loader/Loader";
import {ErrorPage} from "../../../../error/ErrorPage";
import {ApiFilterConverter} from "../../../../../services/helpers/apiFilterConverter";


const apiFilterConverter = new ApiFilterConverter();

export function KpiTargetFilterConfigurationStep(props: KpiProps) {

    const authContext = useAuth();

    const [state, setState] = useState<KpiFilterState>({
        userTypes: userTypes(),
        refreshTypes: refreshTypes(),
        loading: true,
        activeStatus: [
            toSelectableItem("ACTIVE"),
            toSelectableItem("INACTIVE")
        ],
        users: [],
        designations: []
    });

    function refreshTypes() {
        const isHardRefresh = props.kpiInfo.extendedAttributes && props.kpiInfo.extendedAttributes.refreshMode === 'HARD'
        return [
            {
                item: "SOFT",
                isSelected: !isHardRefresh
            },
            {
                item: "HARD",
                isSelected: isHardRefresh
            }
        ]
    }

    function userTypes() {
        const isOutletLevel = props.kpiInfo.target === 'OUTLET'
        return [
            {
                item: "USER",
                isSelected: !isOutletLevel
            },
            {
                item: "OUTLET",
                isSelected: isOutletLevel
            }
        ]
    }

    useEffect(() => {
        setApiFilter()
        // eslint-disable-next-line
    }, [])

    function toSelectableItem<T>(item: T): SelectableItem<T> {
        return {
            item: item,
            isSelected: false
        }
    }

    function toggleSelectableItem<T>(item: SelectableItem<T>): SelectableItem<T> {
        return {
            ...item, isSelected: !item.isSelected
        }
    }

    async function getDesignations(activeDesignations: string[]): Promise<SelectableItem<Division>[]> {
        const divisions = await getDivisions(authContext);
        return divisions.map(item => ({
            item,
            isSelected: activeDesignations.includes(item.divisionName)
        }))
    }

    async function setApiFilter() {
        try {
            const apiFilters = apiFilterConverter.parse(props.kpiInfo.targetFilter);
            const designations = await getDesignations(apiFilters.designations);
            const activeStatus = state.activeStatus.map(item => ({
                ...item, isSelected: apiFilters.activeStatus.includes(item.item)
            }))
            setState({...state, designations, activeStatus, loading: false})
        } catch (er) {
            const message = (er instanceof Error) ? er.message : String(er);
            setState({...state, error: message, loading: false})
        }
    }


    function toChips(items: SelectableItem<string>[]) {
        return items.map(i => <Chip type={"checkbox"} color="red" key={i.item} value={i.item} checked>{i.item}</Chip>)
    }

    function toActiveChips(items: SelectableItem<string>[]): string[] {
        return items.filter(i => i.isSelected).map(i => i.item)
    }

    function setUserType(value: 'OUTLET' | 'USER') {
        const types = [...state.userTypes].map(i => i.item === value ? toggleSelectableItem(i) : toSelectableItem(i.item))
        console.log(types)
        setState({...state, userTypes: types})
        props.setKpiInfo({...props.kpiInfo, target: value});
    }

    function setRefreshType(value: 'HARD' | 'SOFT') {
        const types = [...state.refreshTypes].map(i => i.item === value ? toggleSelectableItem(i) : toSelectableItem(i.item))
        console.log(types)
        setState({...state, refreshTypes: types})
        props.setKpiInfo({...props.kpiInfo, extendedAttributes: {
            ...props.kpiInfo.extendedAttributes,
            refreshMode: value
        }});
    }

    if (state.loading) {
        return <Loader/>
    }
    if (state.error) {
        return <ErrorPage description={state.error}/>
    }
    console.log(state)

    function onDivisionChange(divisions: string[]) {
        const designations = state.designations.map(i => ({
            ...i,
            isSelected: divisions.includes(i.item.divisionName)
        }))
        updateState({...state, designations})
    }

    function updateState(filterState: KpiFilterState) {
        const filters = apiFilterConverter.generateTargetFilter(filterState)
        props.setKpiInfo({...props.kpiInfo, targetFilter: filters})
        setState(filterState)
    }

    function setActiveStatus(status: string[]) {
        const newStatus = state.activeStatus.map(i => ({
            ...i,
            isSelected: status.includes(i.item)
        }))
        updateState({...state, activeStatus: newStatus});
    }

    return (<div className="kpi-filter-wrapper full-width-height wizard-content-card">
        <div className="kpi-filter-section">
            <div className="kpi-filter-section-header">
                <h3>Target Type</h3>
            </div>
            <Chips spacing="lg" value={toActiveChips(state.userTypes)[0]} onChange={setUserType} size="md" color="teal"
                   multiple={false}>
                {toChips(state.userTypes)}
            </Chips>
        </div>
        <div className="kpi-filter-section">
            <div className="kpi-filter-section-header">
                <h3>Designations</h3>
            </div>
            <Chips spacing="lg" size="md"
                   value={state.designations.filter(i => i.isSelected).map(i => i.item.divisionName)}
                   onChange={onDivisionChange} color="teal" multiple>
                {state.designations && state.designations.map(division => <Chip checked={true} key={division.item.id}
                                                                                value={division.item.divisionName}>{division.item.divisionName}</Chip>)}
            </Chips>
        </div>
        <div className="kpi-filter-section">
            <div className="kpi-filter-section-header">
                <h3>User Status</h3>
            </div>
            <Chips spacing="lg" size="md" color="teal" multiple={true} value={toActiveChips(state.activeStatus)}
                   onChange={setActiveStatus}>
                {toChips(state.activeStatus)}
            </Chips>
        </div>
        <div className="kpi-filter-section">
            <div className="kpi-filter-section-header">
                <h3>Refresh Mode</h3>
            </div>
            <Chips spacing="lg" value={toActiveChips(state.refreshTypes)[0]} onChange={setRefreshType} size="md" color="teal"
                   multiple={false}>
                {toChips(state.refreshTypes)}
            </Chips>
        </div>
    </div>);
}

